import React from 'react'
import styled from 'styled-components'

interface MainWrapperProps {
    $noPadding?: boolean;
    $backgroundColor?: string;
    $borderLess?: boolean;
}

const MainWrapper = styled.div<MainWrapperProps>`
    width: 100%;
    height: 100%;
    padding: ${props => props.$noPadding ? '1em 0' : '1em 0.5em'};
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
   
    background: ${props => props.$backgroundColor ? props.$backgroundColor : '#fdfdfd'} ;
    overflow-y: auto;
    overflow-x: hidden;

    gap: 0.5em;
    border-radius: ${props => props.$borderLess ? "0" : '30px'} ;
    &::-webkit-scrollbar {
        width: 0;
    }
`

interface TitlesListProps<T> {
    list: T[] | null | undefined;
    uniqueKey: keyof T;
    additionalData?: Record<string, any>;
    Element: React.ComponentType<any>;
    queryRender?: ((item: T) => boolean) | boolean;
    noPadding?: boolean;
    backgroundColor?: string;
    borderLess?: boolean;
}

export default function TitlesList<T>({ 
    list, 
    uniqueKey, 
    additionalData, 
    Element, 
    queryRender, 
    noPadding = false, 
    backgroundColor, 
    borderLess = false 
}: TitlesListProps<T>) {
    return (
        <MainWrapper 
            $noPadding={noPadding} 
            $backgroundColor={backgroundColor}
            $borderLess={borderLess}
        >
            {
                queryRender ?
                    list?.map((item, index) => {
                        if (typeof queryRender === 'function' && queryRender(item)) {
                            return <Element
                                key={String(item[uniqueKey])}
                                index={index}
                                item={item}
                                {...item}
                                {...additionalData}
                            />
                        }
                        else return null
                    })
                    :
                    list?.map((item, index) =>
                        <Element
                            key={String(item[uniqueKey] || index)}
                            index={index}
                            item={item}
                            {...item}
                            {...additionalData}
                        />
                    )
            }
            <div 
                id='last-item'
                style={{
                    opacity: '0', 
                    width: '100%',
                    height: '1em',
                    background: 'red'
                }}
            >123</div>
        </MainWrapper>
    )
} 